const light = {
  bgimage: `url('/Menu/assets/images/background-pizzahut.jpg')`,
  body: {
    bg: "#fff",
  },
  nav: {
    // bg: "#d60000",
    bg: "#2f2f2f",
  },
  menutab: {
    bg: "#ffffff",
    selected: "#2f3037",
    text: "#0000008a"
  },
  content: {
    bg: "#fff",
  },
  bg: {
    primary: "#eff0f5",
    secondary: "#ffffff",
  },
  bgloading: {
    primary: "#ffffff80",
  },
  text: {
    primary: "#050505",
    secondary: "#2f3037",
    tertiary: "#525560",
    quarternary: "#9194a1",
    error: "#e13340",
  },
  textborder: {
    primary: "#9e9e9e4a",
    secondary: "#504f4f4a",
    error: "#e13340",
  },
  sectionborder: {
    primary: "#e4e4e4"
  }
};

const dark = {
  bgimage: `url('/Menu/assets/images/background-pizzahut_dk.jpg')`,
  body: {
    bg: "#212121",
  },
  nav: {
    bg: "#242526",
  },
  menutab: {
    bg: "#252525",
    selected: "#ffffff",
    text: "#8a8a8a"
  },
  content: {
    bg: "#2f2f2f",
  },
  bg: {
    primary: "#050505",
    secondary: "#111111",
  },
  bgloading: {
    primary: "#000000a8",
  },
  text: {
    primary: "#fbfbfc",
    secondary: "#e3e4e8",
    tertiary: "#a9abb6",
    quarternary: "#6c6f7e",
    error: "#e13340",
  },
  textborder: {
    primary: "#ffffff6e",
    secondary: "#ffffffb3",
    error: "#e13340",
  },
  sectionborder: {
    primary: "#ffffff42"
  }
};

const defaultTheme = {
  fontSizes: [
    "14px", // 0
    "16px", // 1
    "18px", // 2
    "22px", // 3
    "26px", // 4
    "32px", // 5
    "40px", // 6
  ],
  fontWeights: {
    body: 400,
    subheading: 500,
    link: 600,
    bold: 700,
    heading: 800,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.3,
    code: 1.6,
  },
  // ...
};

export const lightTheme = { ...defaultTheme, ...light };
export const darkTheme = { ...defaultTheme, ...dark };
